import React from 'react';
import Box from 'components/Box';
import BoxBody from 'components/BoxBody';
import Button from 'components/Button';
import Heading from 'components/Heading';
import MediaObject from 'components/MediaObject';
import Row from 'components/Row';
import Text from 'components/Text';

type Props = {
  figure: React.ReactElement;
  heading: string;
  copy: React.ReactNode;
  cta?: {
    onClick?: () => void;
    to?: string;
    text: string;
  };
};

export default function TutoringAnnouncementBanner(props: Props) {
  const { figure, heading, copy, cta } = props;

  return (
    <Box noShadow>
      <BoxBody size="xsmall">
        <MediaObject center gutter="small">
          {figure}
          <Text align="left">
            <Heading level="4" flush>
              {heading}
            </Heading>
            <Text element="div">{copy}</Text>
            {cta && (
              <>
                <Row size="xxsmall" />
                <Button size="small" onClick={cta.onClick} to={cta.to}>
                  {cta.text}
                </Button>
              </>
            )}
          </Text>
        </MediaObject>
      </BoxBody>
    </Box>
  );
}
